<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    <div class="panel panel-default">
      <div class="panel-body">
        
        <!-- First Row: Consol Group Key, Tax Year, Group Name -->
        <div class="form-group-row mb-0">
          <div class="col-md-4">
            <label for="consol-group-key"><b>Consol Group Key<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="consol-group-key" 
                   name="consol-group-key" 
                   placeholder=""
                   [(ngModel)]="consolEntity.CONSOL_GROUP_KEY" 
                   [disabled]="isEdit">
            @if (consolEntity.CONSOL_GROUP_NOT_VALID && !consolEntity.CONSOL_GROUP_KEY) {
<small class="text-danger"
                  >
              Please provide Consol Group Key
            </small>
}
          </div>
          
          <div class="col-md-4">
            <div class="form-group">
              <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
              <input type="text" 
                     class="form-control" 
                     id="tax-year" 
                     name="tax-year" 
                     placeholder=""
                     [(ngModel)]="consolEntity.TAX_YEAR" 
                     readonly>
            </div>
            @if (consolEntity.TAX_YEAR_NOT_VALID && !consolEntity.TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide Tax Year
            </small>
}
          </div>
          
          <div class="col-md-4">
            <label for="group-name"><b>Group Name<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="group-name" 
                   name="group-name"
                   placeholder="" 
                   [(ngModel)]="consolEntity.GROUP_NAME">
            @if (consolEntity.GROUP_NAME_NOT_VALID && !consolEntity.GROUP_NAME) {
<small class="text-danger"
                  >
              Please provide Group Name
            </small>
}
          </div>
        </div>

        <!-- Second Row: Return Date, IRS Center Name, Parent LEID -->
        <div class="form-group-row">
          <div class="col-md-4">
            <label for="return-date"><b>Return Date:<sup>*</sup></b></label>
            <input type="date" 
                   class="form-control background-gray" 
                   id="return-date" 
                   name="return-date"
                   [(ngModel)]="consolEntity.RETURN_DATE"
                   required />
            @if (consolEntity.RETURN_DATE_NOT_VALID && !consolEntity.RETURN_DATE) {
<small class="text-danger"
                  >
              Please provide Return Date
            </small>
}
          </div>
          
          <div class="col-md-4">
            <label for="irs-center-name"><b>IRS Center Name</b></label>
            <input type="text" 
                   class="form-control" 
                   id="irs-center-name" 
                   name="irs-center-name"
                   placeholder="" 
                   [(ngModel)]="consolEntity.IRS_CENTER_NAME">
          </div>

          <div class="col-md-4">
            <label for="parent-leid"><b>Parent LEID:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="parent-leid" 
                   name="parent-leid" 
                   placeholder=""
                   [(ngModel)]="consolEntity.PARENT_LEID">
          </div>
        </div>

        <!-- Third Row: Filer Tax Year Begin, Filer Tax Year End, Short Display Name, Gilti Consol Group Key -->
        <div class="form-group-row">
          <div class="col-md-3">
            <label for="filer-tax-year-begin"><b>Filer Tax Year Begin:<sup>*</sup></b></label>
            <input type="date"
                   placeholder=""
                   class="form-control background-gray" 
                   id="filer-tax-year-begin" 
                   name="filer-tax-year-begin"
                   [(ngModel)]="consolEntity.FILER_TAX_YEAR_BEGIN"
                   required />
            @if (consolEntity.FILER_TAX_YEAR_BEGIN_NOT_VALID && !consolEntity.FILER_TAX_YEAR_BEGIN) {
<small class="text-danger"
                  >
              Please provide Date
            </small>
}
          </div>
          
          <div class="col-md-3">
            <label for="filer-tax-year-end"><b>Filer Tax Year End:<sup>*</sup></b></label>
            <input type="date" 
                   class="form-control background-gray" 
                   id="filer-tax-year-end" 
                   name="filer-tax-year-end"
                   [(ngModel)]="consolEntity.FILER_TAX_YEAR_END"
                   required />
            @if (consolEntity.FILER_TAX_YEAR_END_NOT_VALID && !consolEntity.FILER_TAX_YEAR_END) {
<small class="text-danger"
                  >
              Please provide Date
            </small>
}
          </div>
          
          <div class="col-md-3">
            <label for="short-display-name"><b>Short Display Name:<sup>*</sup></b></label>
            <input type="text" 
                   class="form-control" 
                   id="short-display-name" 
                   name="short-display-name"
                   placeholder="" 
                   [(ngModel)]="consolEntity.SHORT_DISPLAY_NAME">
            @if (consolEntity.SHORT_DISPLAY_NAME_NOT_VALID && !consolEntity.SHORT_DISPLAY_NAME) {
<small class="text-danger"
                  >
              Please provide Short Display Name
            </small>
}
          </div>
          
          <div class="col-md-3">
            <label for="gilti-consol-group-key"><b>Gilti Consol Group Key:<sup>*</sup></b></label>
            <input type="text" 
                   class="form-control" 
                   id="gilti-consol-group-key" 
                   name="gilti-consol-group-key" 
                   placeholder=""
                   [(ngModel)]="consolEntity.GILTI_CONSOL_GROUP_KEY">
            @if (consolEntity.GILTI_CONSOL_GROUP_KEY_NOT_VALID && !consolEntity.GILTI_CONSOL_GROUP_KEY) {
<small class="text-danger"
                  >
              Please provide Gilti Consol Group Key
            </small>
}
          </div>
        </div>

      </div>
    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="button-cancel" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
